/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {ProgramEnvironmentalBenefitsTargetValueViewer} from "./ProgramEnvironmentalBenefitsTargetValueViewer";

export const ModelUpliftEnvironmentalBenefitsTargetValueViewer = (props) => {

	const {Data} = props;
	const environmentalBenefitId = Data?.SampleEvent?.environmentalBenefitId ?? -1;

	return <ProgramEnvironmentalBenefitsTargetValueViewer
		{...props}
		environmentalBenefitId={environmentalBenefitId}
	/>
	
}
